import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "block" }
const _hoisted_2 = { class: "block" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_StoreDetail = _resolveComponent("StoreDetail")!
  const _component_BlockMaxWidthHandler = _resolveComponent("BlockMaxWidthHandler")!

  return (_openBlock(), _createBlock(_component_BlockMaxWidthHandler, null, {
    default: _withCtx(() => [
      (_ctx.storeId)
        ? (_openBlock(), _createBlock(_component_StoreDetail, {
            key: 0,
            id: _ctx.storeId,
            heading: _ctx.labels.heading
          }, {
            default: _withCtx(({ store }) => [
              _createElementVNode("span", _hoisted_1, _toDisplayString(store.salesManager?.name), 1),
              _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.labels.salesManagerTitle), 1)
            ]),
            _: 1
          }, 8, ["id", "heading"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}